module.exports = __webpack_public_path__ + "img/but_selected.40b9529a.png";